import { React, Fragment, useState, useRef, useEffect } from "react";
import "./Bookmarks.scss";
import axios from "axios";
import "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNoteSticky, faTrash, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import * as fontIcons from "@fortawesome/free-solid-svg-icons";
import { Menu, Dialog, Transition } from "@headlessui/react";
import ThreeDots from "../../assets/icons/threeDots.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import { useParams } from "react-router-dom";
import ListView from "../../assets/icons/listView.svg";
import compactCardIcon from "../../assets/icons/gridcard.svg";
















import ListviewIcon from "../../assets/icons/listBlackIcon.svg";
import GridviewIcon from "../../assets/icons/gridgreyIcon.svg";

import { toastify } from "../../components/Toast";
import "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import DismissButton from "../../assets/icons/dismissButton.svg";

import LightDelete from "../../assets/icons/Grey_Delete.svg";
import SortMbl from "../../assets/icons/sortmbl.svg";

import NewSingleCard from "../../shades/cards/NewSingleCard";
import DrawerTagFilter from "../DrawerTagFilter/DrawerTagFilter";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import BlackDismiss from "../../assets/icons/dismissButton.svg";
import ShareCard from "../../shades/cards/shareCard";
import Quill from "quill";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import Arrow from "../../assets/icons/arrow.svg";
import MoveModal from "../../shades/cards/includes/MoveModal";
function BookmarksPopup({ bucketName }) {
  let [isOpenss, setIsOpens] = useState(false);
  const [isListBookmarksView, setIsListBookmarksView] = useState(true);
  const [isGridBookmarksView, setIsGridBookmarksView] = useState(true);
  const [isListBookmarksViewIcon, setIsListBookmarksViewIcon] = useState(false);
  const [isGridBookmarksViewIcon, setIsGridBookmarksViewIcon] = useState(false);
  const [isListBookmarksViewOpen, setIsListBookmarksViewOpen] = useState(false);
  const [, setIsGridBookmarksViewOpen] = useState(true);
  const [bookmarksfilespopup, setBookmarksfilesPopup] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [inputValueSet, setInputValueSet] = useState("");
  const [tags, setTags] = useState([]);
  useState([]);
  useRef(null);
  useState("");
  useState([]);
  useState(0);
  useState("");
  const [bookmarkCards, setBookMarkCards] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const [bookmarksRefresh, setbookmarksRefresh] = useState(0);
  useState("");
  const [isLoadings, setIsLoadings] = useState(true);
  const [loadError, setLoadError] = useState(false);
  useState("");
  const [cardsCount, setCardsCount] = useState("");
  const [bookmarkUrl, setBookmarkUrl] = useState("");
  const [notes, setNotes] = useState("");
  const [isEditorFocused, setIsEditorFocused] = useState(false);
  const [isTagOpen, setIsTagOpen] = useState(false);
  const [filterTag, setFiltertag] = useState("");
  const [filterTagId, setFilterTagId] = useState("");
  const [BookmarkSharePopup, setBookmarkSharePopup] = useState(false);
  const [ShareBookmarkId, setShareBookmarkId] = useState("");
  const [buckets, setBuckets] = useState([]);
  const [appTheme, setAppTheme] = useState("");
  const [moveModal, setMoveModal] = useState(false);
  const [openMove, setOpenMove] = useState(false);
  useEffect(() => {
    const handleStorageChange = () => {
      const theme = localStorage.getItem("theme");
      setAppTheme(theme);
    };

    window.addEventListener("storage", handleStorageChange);

    // Force a re-render when localStorage changes
    setAppTheme(localStorage.getItem("theme"));

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem("token");
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}buckets/user-buckets`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        ); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, []);

  const modules = {
    clipboard: {
      matchVisual: false,
    },
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: [] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        {
          color: [
            "#FF0000", // Red
            "#00FF00", // Green
            "#0000FF", // Blue
            "#FFFF00", // Yellow
            "#00FFFF", // Cyan
            "#FF00FF", // Magenta
            "#000000", // Black
            "#FFFFFF", // White
            "#808080", // Gray

            // Web-safe colors
            "#800000", // Maroon
            "#808000", // Olive
            "#000080", // Navy
            "#800080", // Purple
            "#008080", // Teal
            "#C0C0C0", // Silver
            // Shades of gray
            "#A9A9A9", // Dark gray
            "#696969", // Dim gray
            "#D3D3D3", // Light gray
            "#DCDCDC", // Gainsboro

            // Pastel colors
            "#FFB6C1", // Light pink
            "#90EE90", // Light green
            "#ADD8E6", // Light blue
            "#E6E6FA", // Lavender

            // CSS named colors
            "#FF6347", // Tomato
            "#F4A460", // Sandy Brown
            "#6495ED", // Cornflower Blue
            "#9932CC", // Dark Orchid
          ],
        },
      ],
      [
        {
          background: [
            "#FF0000", // Red
            "#00FF00", // Green
            "#0000FF", // Blue
            "#FFFF00", // Yellow
            "#00FFFF", // Cyan
            "#FF00FF", // Magenta
            "#000000", // Black
            "#FFFFFF", // White
            "#808080", // Gray

            // Web-safe colors
            "#800000", // Maroon
            "#808000", // Olive
            "#000080", // Navy
            "#800080", // Purple
            "#008080", // Teal
            "#C0C0C0", // Silver
            // Shades of gray
            "#A9A9A9", // Dark gray
            "#696969", // Dim gray
            "#D3D3D3", // Light gray
            "#DCDCDC", // Gainsboro

            // Pastel colors
            "#FFB6C1", // Light pink
            "#90EE90", // Light green
            "#ADD8E6", // Light blue
            "#E6E6FA", // Lavender

            // CSS named colors
            "#FF6347", // Tomato
            "#F4A460", // Sandy Brown
            "#6495ED", // Cornflower Blue
            "#9932CC", // Dark Orchid
          ],
        },
      ],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ];
  const bucketNav = [
    // {icon:faPencil, name: 'Edit Name', href: 'javascript:void(0)' },
    { icon: faNoteSticky, name: "Select All",  },
    { icon: faTrash, name: "Unselect All",  },
  ];
  const closeSharePop = () => {
    setBookmarkSharePopup(false);
  };

  const bucketId = useParams();
  const filterFilesDropDown = [
    { name: "Created Date", href: "#" },
    { name: "Recent Activity", href: "#" },
    { name: "Ascending Order", href: "#" },
    { name: "Descending Order", href: "#" },
  ];
  const handleProcedureContentChange = (content, delta, source, editor) => {
    setNotes(content);
  };
  const handleEditorClick = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handlePaste = (event) => {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedHTML = clipboardData.getData("text/html");
    const quill = this.reactQuillRef.getEditor();
    const selection = quill.getSelection();
    const index = selection ? selection.index : 0;
    const delta = quill.clipboard.convert(pastedHTML);
    quill.updateContents(delta, Quill.sources.USER);
    quill.setSelection(index + delta.length(), Quill.sources.SILENT);
  };
  const handleEditorBlur = () => {
    setIsEditorFocused(false);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("my-class-selected");
    }
  };
  const handleSharePop = (id) => {
    setShareBookmarkId(id);
    setBookmarkSharePopup(true);
  };
  const handleKeyUp = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handleEditorFocus = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handleAddBookmarks = async () => {
    const tagsPayload = JSON.stringify(tags.map((tag) => ({ name: tag })));
    const token = localStorage.getItem("token");
    const userData = JSON.parse(localStorage.getItem("userData"));
    const formData = new FormData();
    const content = {
      html: "test",
      sourceUrl:
        bookmarkUrl && !bookmarkUrl.startsWith("https://")
          ? "https://" + bookmarkUrl
          : bookmarkUrl,
      imageUrl: [],
    };
    const data = JSON.stringify(content);

    formData.append("tags", tagsPayload);
    formData.append("note", notes);
    formData.append("title", "title");
    formData.append("userId", userData._id);
    formData.append("bucketId", bucketId.id);
    formData.append("cardType", "bookmark");
    formData.append("content", data);
    formData.append(
      "postDetail",
      JSON.stringify({ title: "sdasdas", imageUrl: "sdasdsadsad" })
    );
    try {
      await axios.post(
        `${process.env.REACT_APP_API}cards/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      closeBookmarksfilesPopup();
      setIsLoadings(true);
      setbookmarksRefresh((refresh) => refresh + 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  let cardFilterv = "";
  if (!localStorage.getItem("cardFilter")) {
    localStorage.setItem("cardFilter", "Created_Date");
    cardFilterv = "Created_Date";
  } else {
    cardFilterv = localStorage.getItem("cardFilter");
  }
  const [cardFilterDefault, setCardFilterDefault] = useState(cardFilterv);
  const [FiltersSelectText, setFiltersSelectText] = useState(
    cardFilterv === "Created_Date"
      ? filterFilesDropDown[0].name
      : cardFilterv === "Descending_Order"
        ? filterFilesDropDown[3].name
        : cardFilterv === "Ascending_Order"
          ? filterFilesDropDown[2].name
          : ""
  );
  const fetchTags = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API}tags/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      setTagOptions(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const MoveCard = async () => {
    setMoveModal(true)
    setOpenMove(true);
  };

  const closeMove = () => {
    // setIsBucketOpen(false);
    // setSelectedItems("")
    setSelectedItems([])
    setMoveModal(false)
    setOpenMove(false);
    // setselectedBucketId("");
    // setSearchBucket("");
  };
  useEffect(() => {
    fetchTags();
  }, []);
  const handleSortFilterText = async (text) => {
    // setFiltersText(text);

    setFiltersSelectText(text);
    const filterValues =
      text === "Created Date"
        ? "Created_Date"
        : text === "Descending Order"
          ? "Descending_Order"
          : text === "Ascending Order"
            ? "Ascending_Order"
            : text === "Recent Activity"
              ? "Recent_Activity"
              : "";
    localStorage.setItem("cardFilter", filterValues);
    setIsLoadings(true);
    setbookmarksRefresh((refresh) => refresh + 1);
    setCardFilterDefault(filterValues);
  };
  useEffect(() => {
    // This request belongs to the current route/filter; ignore responses after cleanup.
    let active = true;
    setIsLoadings(true);
    setLoadError(false);

    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}cards/cardList-by-bucketId`,
          {
            bucketId: `${bucketId.id}`,
            filterValue: cardFilterDefault,
            page: 1,
            limit: 100000,
            type: "BookMark",
            tagId: filterTagId ? filterTagId : "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!active) return;
        setBookMarkCards(response?.data?.data?.cardsList || []);
        setCardsCount(response?.data?.data?.totalCards);
      } catch (error) {
        if (!active) return;
        console.error(error);
        setBookMarkCards([]);
        setCardsCount(0);
        setLoadError(true);
      } finally {
        if (active) setIsLoadings(false);
      }
    };

    fetchData(); // Call the async function immediately

    // The empty dependency array means this effect runs once after initial render.

    return () => { active = false; };
  }, [bookmarksRefresh, filterTagId, bucketId.id, cardFilterDefault]);
  const handleDeleteCard = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}cards/delete`,
        {
          data: { deletedIds: selectedItems },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toastify("success", response.data.message);
      setSelectedItems([]);
      closeCardModal();
      cardsRefresh();
    } catch (error) {
      console.error(error);
      closeCardModal();
      toastify("error", error.response.data.message);
    }
  };
  const cardsRefresh = () => {
    setIsLoadings(true);
    setbookmarksRefresh((refresh) => refresh + 1);
  };
  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      const newTag = selectedOption.name;
      setTags([...tags, newTag]);

      setInputValueSet("");
      handleTagsChange([...tags, newTag]);
      handleBlur();
    }
  };
  const handleTagsChange = (newTags) => {
    setTags(newTags);
    const inputElement = document.querySelector(".react-tagsinput-input");

    // Check if the input element exists before calling focus
    if (inputElement) {
      inputElement.focus();
    }
  };
  const handleBlur = () => {
    setIsTagOpen(false);
  };
  const filteredOptions = tagOptions.filter((option) =>
    option.name.toLowerCase().includes(inputValueSet.toLowerCase())
  );

  const handleSetInputValue = (e) => {
    setInputValueSet(e);
    setIsTagOpen(true);
  };

  const handleFocus = (e) => {
    e.stopPropagation();
    setIsTagOpen(true);
  };
  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== value)
      );
    }
  };

  const handleClick = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handleCardClick = (text) => {
    if (text === "Select All") {
      setSelectedItems(bookmarkCards.map((card) => card._id));
    } else if (text === "Unselect All") {
      setSelectedItems([]);
    }
  };

  const handleIsGridBookmarksView = () => {
    setIsListBookmarksView(true);
    setIsGridBookmarksView(true);
    setIsGridBookmarksViewOpen(true);
    setIsListBookmarksViewOpen(false);
    setIsListBookmarksViewIcon(false);
  };

  const handleIsListBookmarksView = () => {
    setIsListBookmarksView(false);
    setIsGridBookmarksView(false);
    setIsListBookmarksViewOpen(true);
    setIsGridBookmarksViewOpen(false);
    setIsListBookmarksViewIcon(true);
    setIsGridBookmarksViewIcon(true);
  };

  const handleIsListBookmarksViewIcon = () => {
    setIsListBookmarksView(true);
    setIsGridBookmarksView(false);
    setIsListBookmarksViewOpen(false);
    setIsGridBookmarksViewOpen(true);
    setIsListBookmarksViewIcon(false);
    // setIsGridViewIcon(true)
  };

  const handleIsGridBookmarksViewIcon = () => {
    setIsListBookmarksView(true);
    setIsGridBookmarksView(true);
    setIsListBookmarksViewOpen(false);
    setIsGridBookmarksViewOpen(true);
    setIsListBookmarksViewIcon(false);
    setIsGridBookmarksViewIcon(false);
  };





  const handleBookmarksfilesPopup = () => {
    setBookmarksfilesPopup(true);
  };


  function closeBookmarksfilesPopup() {
    setBookmarksfilesPopup(false);
    setBookmarkUrl("");
    setTags([]);
    setNotes("");

    setIsTagOpen(false);
    setInputValueSet("");
  }


  function closeCardModal() {
    // setSelectedItems([]);
    setIsOpens(false);
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      <div className="bookmarksGrid-wholesection">
          <div className="bucketHeader">
            <div className="grid grid-cols">
              <div className="bucketFeature col-span-2">
                <div className="flex items-center">
                  <h2 className="text-xl mybuckets-content dark:text-[#fff]">
                    Bookmarks
                  </h2>
                  {/* <div className="subbucketheaderdesktop-section">
                    <button
                      style={{
                        filter:
                          "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                      }}
                      className="buttonpadding-content mx-8 text-[16px] rounded-full bg-[#FF6600] text-white pr-[32px]"
                      onClick={handleBookmarksfilesPopup}
                    >
                      <FontAwesomeIcon
                        className="pl-[23px] pr-[17.73px]"
                        icon={fontIcons.faPlus}
                      />
                      <span className="createbutton-context">Add</span>
                    </button>
                  </div> */}
                  <div className="subbucketheadermbl-section">
                    <button
                      style={{
                        filter:
                          "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                      }}
                      className="buttonpadding-content mx-2 text-[16px] rounded-full bg-[#FF6600] text-white pr-[32px]"
                      onClick={handleBookmarksfilesPopup}
                    >
                      <FontAwesomeIcon
                        className="pl-[23px] pr-[17.73px]"
                        icon={fontIcons.faPlus}
                      />
                      <span className="createbutton-context">Add</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {bookmarksfilespopup && (
            <div
              className="bookmarksfilesuploadpopup relative !z-[999]"
              style={{ height: "100%" }}
              onClick={closeBookmarksfilesPopup}
            >
              <div
                className="bookmarkssubfilesupload-section ss"
                onClick={(e) => {
                  e.stopPropagation();

                  setIsTagOpen(false);
                }}
              >
                <div className="fileupload-section flex">
                  <div className="fileupload-content">Add Bookmark</div>
                  <div
                    className="dismissSubfiles-content"
                    onClick={closeBookmarksfilesPopup}
                  >
                    <img src={DismissButton} alt="dismissButton" />
                  </div>
                </div>
                <hr />
                <div className="uploadtext-content">
                  Enter url to save website
                </div>
                <div className="flex items-center rounded-3xl border-0 menusubitems-content">
                  <input
                    type="text"
                    placeholder="Enter URL"
                    className="filespopupbg-content"
                    value={bookmarkUrl}
                    onChange={(e) => setBookmarkUrl(e.target.value)}
                    autoFocus
                  />
                </div>
                <div className="flex items-center rounded-3xl border-0 menusubitems-content">
                  <input
                    type="text"
                    placeholder="Select a bucket"
                    className="filespopupbg-content"
                    value={bucketName}
                    readOnly
                  />

                  {/* <div><FontAwesomeIcon className="iconimg-content" style={{ fontSize: '12px', color: '#707070' }} icon={faChevronDown} /></div> */}
                </div>
                <div className="pos-tagsdropdown">
                  <div
                    className="flex items-center rounded-3xl border-0 menusubitems-content"
                    onClick={handleFocus}
                  >
                    <div className="w-full">
                      <div className="flex bookmarks-tags">
                        <TagsInput
                          value={tags}
                          onChange={handleTagsChange}
                          inputValue={inputValueSet}
                          onChangeInput={(e) => handleSetInputValue(e)}
                        />
                        <FontAwesomeIcon
                          className="fileicon-content"
                          style={{}}
                          icon={faChevronDown}
                          onClick={handleFocus}
                        />
                      </div>

                      {/* <button onClick={handleAddFromDropdown}>Add Tag from Dropdown</button> */}
                    </div>
                  </div>
                  {isTagOpen && (
                    <div className="pos-dropdown">
                      {/* <input
type="text"
placeholder="Search a tag"
value={searchTerm}
onChange={handleInputChange}

/> */}

                      <nav>
                        <div className="tab-scrolls tagscard">
                          <ul className="dropdown">
                            {filteredOptions.map((option) => (
                              <li key={option._id}>
                                <p onClick={() => handleSelectChange(option)}>
                                  {option.name}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </nav>
                    </div>
                  )}
                </div>
                <div
                  className="border bg-[#f5f5f5] border-[#e5e5e5] dark:border-[#e5e5e5] border-1 rounded-md overflow-hidden"
                  onClick={handleClick}
                  style={{
                    resize: "horizontal",
                    height: "200px",
                    marginBottom: "30px",
                  }}
                >
                  {(isEditorFocused === false && !notes) ||
                    (isEditorFocused === false && notes === "<p><br></p>") ? (
                    <div
                      className="addnote-text"
                      style={{ paddingLeft: "14px", marginTop: "10px" }}
                    >
                      <p>Add Notes</p>
                    </div>
                  ) : (
                    ""
                  )}
                  <ReactQuill
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    value={notes}
                    onChange={handleProcedureContentChange}
                    onFocus={handleEditorFocus}
                    onClick={handleEditorClick}
                    onBlur={handleEditorBlur}
                    onKeyUp={handleKeyUp}
                    onPaste={handlePaste}
                  />
                  {isEditorFocused && (
                    <div
                      className="backgroundcard-rightcontent bg-[#F7F7F7] px-3 py-4 flex items-center"
                      onClick={handleClick}
                    >
                      {notes}
                    </div>
                  )}

                  {/* <input
type="text"
className="createdsubtext-content pr-4"
value={notes}
onChange={handleAddNotes}
/> */}
                </div>
                <div className="flex justify-end lastfile-section">
                  <div
                    className="cancel-content"
                    onClick={closeBookmarksfilesPopup}
                    style={{ cursor: "pointer" }}
                  >
                    Cancel
                  </div>
                  <button
                    style={{
                      filter: "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                    }}
                    className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white"
                  >
                    <span
                      className="savebutton-context"
                      onClick={handleAddBookmarks}
                    >
                      Upload
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}
          {BookmarkSharePopup && (
            <div
              className="filesuploadpopup relative !z-[999]"
              style={{ height: "100%" }}
              onClick={closeSharePop}
            >
              <div
                className="subinviteupload-section"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="teaminvitesection flex">
                  <div className="teammembers-content">Share</div>
                  <div
                    className="dismissSubfiles-content"
                    onClick={closeSharePop}
                  >
                    <img src={BlackDismiss} alt="dismissButton" />
                  </div>
                </div>
                <ShareCard
                  shareBucketId={ShareBookmarkId}
                  closeSharePop={closeSharePop}
                />
              </div>
            </div>
          )}
          <div className="subbucketheaderdesktop-section">
            <div className="cards-filter mt-[18px] flex justify-between">
              <div className="flex items-center">
                <div className="card-count flex items-center">
                  <h4 className="cardssubBuckets-content">Bookmarks</h4>
                  <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">
                    {isLoadings ? "…" : cardsCount}
                  </span>
                </div>
                {isListBookmarksViewOpen ? (
                  <div className="mr-6"></div>
                ) : (
                  <>
                    <Menu as="div" className="relative px-2">
                      <Menu.Button className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 ">
                        {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                        <img
                          className="threedots-content"
                          src={ThreeDots}
                          alt="threeDots"
                        />
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {bucketNav.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <button type="button" data-former-link=""

                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block py-2 px-4 text-sm text-gray-700"
                                  )}
                                  onClick={() => {
                                    handleCardClick(item.name);
                                  }}
                                >
                                  <span className="pr-2">
                                    <FontAwesomeIcon
                                      className="text-[#797979]"
                                      icon={item.icon}
                                    />
                                  </span>
                                  <span className="text-black">
                                    {item.name}
                                  </span>
                                </button>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                    {selectedItems.length > 0 ? (
                      <img
                        src={appTheme === "light" ? DeleteIcon : LightDelete}
                        alt="deleteIcon"
                        className="px-3"
                        onClick={() => setIsOpens(true)}
                      />
                    ) : (
                      <img
                        src={appTheme === "light" ? LightDelete : DeleteIcon}
                        alt="deleteIcon"
                        className="px-3"
                      // onClick={() => deleteCard()}
                      />
                    )}
                    <img src={Arrow} alt="arrow" className="px-3" onClick={MoveCard} />
                  </>
                )}
                {/* <Menu as="div" className="relative flex-shrink-0">
              <div>
                <Menu.Button className="flex rounded-full focus:outline-none bordered">
                  <div href="#" className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500 bucketswhole-spacecontent">
                    <strong className="createdbuckettext-content pr-4">Tags</strong>
                    <FontAwesomeIcon className="dropdownicon-bucketcontent" style={{fontSize:'12px'}} icon={faChevronDown} />
                  </div>
                </Menu.Button>
              </div> 
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">                           
                  {filterBucketsDropDown.map((item) => (
                    <Menu.Item key={item.name}>
                      {({ active }) => (
                        <a
                          onClick={()=>{handleFilterTagText(item.name)}}
                          href={item.href}
                          className={classNames(
                            active ? 'bg-gray-100' : '',
                            'block py-2 px-4 text-[13px] text-gray-700'
                          )}
                        >
                          {item.name}
                        </a>
                      )}
                    </Menu.Item>
                  ))}
                </Menu.Items>
              </Transition>
          </Menu> */}
                <DrawerTagFilter
                  options={tagOptions}
                  selectedId={filterTagId}
                  selectedName={filterTag}
                  onSelect={(option) => {
                    if (option._id === filterTagId) return;
                    setIsLoadings(true);
                    setFiltertag(option.name);
                    setFilterTagId(option._id);
                  }}
                  onClear={() => { setIsLoadings(true); setFiltertag(""); setFilterTagId(""); }}
                />

                <Transition appear show={isOpenss} as={Fragment}>
                  <Dialog
                    as="div"
                    className="relative z-[9999]"
                    onClose={closeCardModal}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                      <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 scale-95"
                          enterTo="opacity-100 scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 scale-100"
                          leaveTo="opacity-0 scale-95"
                        >
                          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                            <Dialog.Title
                              as="h3"
                              className="text-lg font-medium leading-6 text-gray-900"
                            >
                              Delete
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want to delete?
                              </p>
                            </div>

                            <div className="mt-4">
                              <button
                                style={{
                                  background: "#FF6600",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={handleDeleteCard}
                              >
                                Yes
                              </button>
                              <button
                                style={{
                                  background: "#000",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={closeCardModal}
                              >
                                No
                              </button>
                            </div>
                          </Dialog.Panel>
                        </Transition.Child>
                      </div>
                    </div>
                  </Dialog>
                </Transition>
                {/* <FontAwesomeIcon className="transform rotate-45 px-3" icon={faArrowUp } /> */}
              </div>
              <div className="flex">
                <div className="flex items-center justify-end">
                  <div className="filter display-content">
                    {isListBookmarksView && (
                      <div onClick={handleIsListBookmarksView}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 listcard-imgcontent"
                            src={ListView}
                            style={{ color: "#000000" }}
                            alt="listView"
                          />
                        </button>
                      </div>
                    )}
                    {isListBookmarksViewIcon && (
                      <div onClick={handleIsListBookmarksViewIcon}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 listcard-imgcontent"
                            src={ListviewIcon}
                            alt="listviewIcon "
                          />
                        </button>
                      </div>
                    )}
                    {isGridBookmarksView && (
                      <div onClick={handleIsGridBookmarksView}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 compact-imgcontent"
                            src={compactCardIcon}
                            alt="compactIcon"
                          />
                        </button>
                      </div>
                    )}
                    {isGridBookmarksViewIcon && (
                      <div onClick={handleIsGridBookmarksViewIcon}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 compact-imgcontent"
                            src={GridviewIcon}
                            alt="compactIcon"
                          />
                        </button>
                      </div>
                    )}
                  </div>

                  <span className="sorttext-content mx-3 dark:text-[#acacac]">
                    Sort By
                  </span>
                  <Menu as="div" className="relative flex-shrink-0">
                    <div>
                      <Menu.Button className="flex rounded-full focus:outline-none ">
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <strong className="createdtext-content pr-4">
                            {FiltersSelectText}
                          </strong>
                          <FontAwesomeIcon
                            style={{ fontSize: "12px", color: "#707070" }}
                            icon={faChevronDown}
                          />
                        </span>
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {filterFilesDropDown.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <button type="button" data-former-link=""
                                onClick={() => {
                                  handleSortFilterText(item.name);
                                }}

                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block py-2 px-4 text-sm text-gray-700"
                                )}
                              >
                                {item.name}
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>
            </div>
          </div>
          <div className="subbucketheadermbl-section ">
            <div className="cards-filter mt-[18px] ml-[10px] mr-[18px] flex justify-between">
              <div className="flex items-center">
                <div className="card-count flex items-center">
                  <h4 className="cardssubBuckets-content">Bookmarks</h4>
                  <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">
                    {isLoadings ? "…" : cardsCount}
                  </span>
                </div>
                <Menu as="div" className="relative px-2">
                  <Menu.Button className="relative inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 ">
                    {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                    <img
                      className="threedots-content"
                      src={ThreeDots}
                      alt="threeDots"
                    />
                  </Menu.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {bucketNav.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <button type="button" data-former-link=""
                              onClick={() => handleCardClick(item.name)}
                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block py-2 px-4 text-sm text-gray-700"
                              )}
                            >
                              <span className="pr-2">
                                <FontAwesomeIcon
                                  className="text-[#797979]"
                                  icon={item.icon}
                                />
                              </span>
                              <span className="text-black">{item.name}</span>
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
                <img src={DeleteIcon} alt="deleteIcon" className="px-3" />
                {/* <FontAwesomeIcon className="transform rotate-45 px-3" icon={faArrowUp } /> */}
              </div>
              <div className="flex">
                <div className="flex items-center justify-end">
                  <div className="filter display-content">
                    {/* {isListBookmarksView &&
                        <div onClick={handleIsListBookmarksView}>
                        <a className="viewGrid" href="#">                            
                            <img className="mt-1 mr-3" src={ListView} style={{color:'#000000'}}  alt="listView" />
                        </a>
                        </div>
                    }
                    {isListBookmarksViewIcon &&
                      <div onClick={handleIsListBookmarksViewIcon}> 
                        <a className="viewGrid" href="#">                           
                        <img className="mt-1 mr-3" src={ListviewIcon } alt="listviewIcon " />
                        </a>
                      </div>

                    } */}
                    {/* {isGridBookmarksView &&
                        <div onClick={handleIsGridBookmarksView}>
                        <a className="viewGrid" href="#">                            
                            <img className="mt-1 mr-3 compact-imgcontent" src={compactCardIcon} alt="compactIcon" />
                        </a>
                        </div>
                    }
                    {isGridBookmarksViewIcon &&
                        <div onClick={handleIsGridBookmarksViewIcon}>
                        <a className="viewGrid" href="#">                            
                            <img className="mt-1 mr-3 compact-imgcontent" src={GridviewIcon} alt="compactIcon" />
                        </a>
                        </div>
                    } */}
                  </div>

                  <div>
                    <Menu
                      as="div"
                      className="sortmbl-content relative flex-shrink-0"
                    >
                      <div>
                        <Menu.Button className="flex rounded-full dark:text-[#acacac] focus:outline-none">
                          <span data-former-link=""

                            className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500 "
                          >
                            <img src={SortMbl} alt="SortMbl" />
                          </span>
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="filter-dropdown dropdownmbl-content absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {filterFilesDropDown.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <button type="button" data-former-link=""
                                  onClick={() => {
                                    handleSortFilterText(item.name);
                                  }}

                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block py-2 px-4 text-sm text-gray-700"
                                  )}
                                >
                                  {item.name}
                                </button>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bucket-drawer-mobile-tags">
            <DrawerTagFilter
              options={tagOptions}
              selectedId={filterTagId}
              selectedName={filterTag}
              onSelect={(option) => {
                if (option._id === filterTagId) return;
                setIsLoadings(true);
                setFiltertag(option.name);
                setFilterTagId(option._id);
              }}
              onClear={() => { setIsLoadings(true); setFiltertag(""); setFilterTagId(""); }}
            />
          </div>

          <div className={`bucket-drawer-bookmarks ${isListBookmarksViewOpen ? "bucket-drawer-bookmarks--list" : ""}`}>
            {isLoadings ? (
              <div className="bucket-drawer-loading App-loading" role="status" aria-live="polite">
                <div className="App-logo" title="Zimzee" aria-hidden="true" />
                <span>Loading bookmarks…</span>
              </div>
            ) : loadError ? (
              <div className="bucket-drawer-empty" role="alert"><h3>Couldn’t load bookmarks</h3><p>Try changing the filter or reopen the drawer.</p></div>
            ) : bookmarkCards?.length ? bookmarkCards.map((card) => (
              <NewSingleCard
                key={card._id}
                cardId={card._id}
                cardType={card.cardType}
                title={card.title}
                content={card.content}
                postDetail={card.postDetail}
                note={card.note}
                tags={card.tags}
                updated={card.updatedAt || card.createdAt}
                starred={card.starred}
                sharedLength={card.shared?.length || 0}
                sharedBy={card.sharedBy?.fullName}
                buckets={buckets}
                selectedItems={selectedItems}
                handleCheckboxChange={handleCheckboxChange}
                handleSharePop={handleSharePop}
                cardUpdate={cardsRefresh}
                detailUrl={`/app/card-detail/${card._id}`}
              />
            )) : (
              <div className="bucket-drawer-empty"><h3>No bookmarks yet</h3><p>Bookmarks saved to this bucket will appear here.</p></div>
            )}
          </div>
      </div>
      {moveModal ? <MoveModal openMove={openMove} closeModal={closeMove} selectedItems={selectedItems} cardUpdate={cardsRefresh} buckets={buckets} /> : null}
    </>
  );
}
export default BookmarksPopup;
